/**
 * defa.views.LegacyUnitSnippet
 * A view for a single selectable Unit.
 * @version 1.2.1
 */
import Snippet from 'scripts/poppet/snippet';

const LegacyUnitSnippet = Snippet.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	templateContext: function () {
		
		let superContext = Snippet.prototype.templateContext.call( this );
		
		return _.extend( superContext, {
			iconClass : 'device',
			attributes: this.createAttributes(),
			header    : this.model.get( 'alias' ),
		} );
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Adds additional attributes to the main anchor.
	 * @return {String} A string of extra html-attributes.
	 */
	createAttributes: function () {
		return ( this.model.get( 'transientOffline' ) )
			   ? ' disabled'
			   : '';
	},
	
} );

export default LegacyUnitSnippet;